import React from 'react';
import DashboardHeader from '../../../shared/components/DashboardHeader';
import RecruitersTable from "../../../shared/components/admin/tables/RecruitersTable";

export default () =>
    <>
        <DashboardHeader title="Menedżerowie"/>
        <div className="tab-content">
            <div className="tab-pane fade show active">
                <div className="card">
                    <RecruitersTable/>
                </div>
            </div>
        </div>
    </>